export enum CurrencyLocale {
  NL = 'nl-NL',
  EN = 'en-EN'
}
